// src/pages/Profile/components/PushNotificationsCard.jsx

import React from "react";
import {
  FaBell,
  FaCheckCircle,
  FaExclamationTriangle,
  FaMobileAlt,
  FaPaperPlane,
  FaPowerOff,
  FaSyncAlt,
  FaTimes,
} from "react-icons/fa";

import usePushNotificationsPanel from "../hooks/usePushNotificationsPanel";
import ActionButton from "../ui/ActionButton";
import { cn } from "../utils/profileUtils";

export default function PushNotificationsCard({ user, onUserUpdated }) {
  const {
    supported,
    platform,
    isIOSNotStandalone,
    permission,
    loadingStatus,
    saving,
    testing,
    status,
    enablePush,
    disableCurrentDevice,
    disableEverywhere,
    sendTest,
    refreshPushStatus,
    currentDeviceSubscribed,
  } = usePushNotificationsPanel({
    user,
    onUserUpdated,
  });

  const enabled = !!status.push_notifications_enabled;
  const hasDevice = !!currentDeviceSubscribed;
  const hasAnyDevice = !!status.has_active_subscription;

  const statusLabel = enabled
    ? "Notifications push activées"
    : "Notifications push désactivées";

  const statusClass = enabled
    ? "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300"
    : "border-slate-200 bg-slate-50 text-slate-600 dark:border-white/10 dark:bg-white/5 dark:text-slate-300";

  return (
    <div className="mt-8 rounded-[2rem] border border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-white/5">
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex items-start gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-primary/10 text-primary">
              <FaMobileAlt />
            </div>

            <div>
              <h3 className="font-barlow text-xl font-bold text-slate-950 dark:text-white">
                Notifications push smartphone
              </h3>

              <p className="mt-2 text-sm leading-7 text-slate-500 dark:text-slate-400">
                ⚠️ Option non comprise actuellement par votre club. Permet
                d'activer les notifications sur cet appareil pour recevoir les
                alertes importantes du club, même lorsque l’application n’est
                pas ouverte.
              </p>

              {/* <p className="mt-2 text-sm leading-7 text-slate-500 dark:text-slate-400">
                ⚠️ Il faut avant d'activer se déconnecter puis de reconnecter.
                Activez les notifications sur cet appareil pour recevoir les
                alertes importantes du club, même lorsque l’application n’est
                pas ouverte.
              </p> */}

              {/* <div className="mt-3 flex flex-wrap gap-2">
                <span
                  className={cn(
                    "inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-bold",
                    statusClass,
                  )}
                >
                  {enabled ? <FaCheckCircle /> : <FaBell />}
                  {statusLabel}
                </span>

                <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-bold text-slate-500 dark:border-white/10 dark:bg-slate-950/40 dark:text-slate-300">
                  Appareils actifs : {status.active_subscriptions_count || 0}
                </span>

                <p className="mt-3 text-xs leading-5 text-slate-500 dark:text-slate-400">
                  Chaque téléphone, ordinateur ou tablette doit être activé
                  séparément. Le bouton “Désactiver cet appareil” ne coupe que
                  l’appareil en cours. Le bouton “Désactiver partout” coupe tous
                  vos appareils.
                </p>

                <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-bold text-slate-500 dark:border-white/10 dark:bg-slate-950/40 dark:text-slate-300">
                  {platform === "ios"
                    ? "iPhone / iPad"
                    : platform === "android"
                      ? "Android"
                      : "Ordinateur"}
                </span>
              </div> */}
            </div>
          </div>

          {/* <button
            type="button"
            onClick={refreshPushStatus}
            disabled={loadingStatus}
            className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:text-primary disabled:opacity-60 dark:border-white/10 dark:bg-white/5 dark:text-slate-200"
            aria-label="Actualiser le statut push"
          >
            <FaSyncAlt className={cn(loadingStatus && "animate-spin")} />
          </button> */}
        </div>

        {/* {!supported && (
          <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm leading-6 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300">
            <div className="flex items-start gap-3">
              <FaExclamationTriangle className="mt-1 shrink-0" />
              <p>
                Ce navigateur ne supporte pas les notifications push web.
                Essayez avec Chrome, Edge, ou l’application installée sur
                smartphone.
              </p>
            </div>
          </div>
        )} */}

        {/* {isIOSNotStandalone && (
          <div className="rounded-2xl border border-orange-200 bg-orange-50 px-4 py-4 text-sm leading-6 text-orange-800 dark:border-orange-500/20 dark:bg-orange-500/10 dark:text-orange-300">
            <div className="flex items-start gap-3">
              <FaExclamationTriangle className="mt-1 shrink-0" />

              <div>
                <p className="font-bold">
                  Activation nécessaire depuis l’application installée sur
                  iPhone
                </p>

                <p className="mt-2">
                  Sur iPhone, les notifications push web ne fonctionnent pas
                  depuis Safari classique. Il faut d’abord ajouter le site à
                  l’écran d’accueil.
                </p>

                <ol className="mt-3 list-decimal space-y-1 pl-5">
                  <li>Ouvrir le site dans Safari.</li>
                  <li>Appuyer sur le bouton de partage.</li>
                  <li>Choisir “Sur l’écran d’accueil”.</li>
                  <li>Ouvrir MonAppliClub depuis la nouvelle icône.</li>
                  <li>Se connecter puis revenir sur cette page Profil.</li>
                  <li>Cliquer sur “Activer sur cet appareil”.</li>
                </ol>
              </div>
            </div>
          </div>
        )} */}

        {/* {permission === "denied" && (
          <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm leading-6 text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300">
            <div className="flex items-start gap-3">
              <FaTimes className="mt-1 shrink-0" />
              <p>
                Les notifications sont bloquées dans les paramètres du
                navigateur. Il faut les réautoriser depuis les paramètres du
                site.
              </p>
            </div>
          </div>
        )} */}

        {/* <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          {!hasDevice && (
            <ActionButton
              icon={FaBell}
              onClick={enablePush}
              disabled={saving || !supported || permission === "denied"}
            >
              {saving ? "Activation..." : "Activer sur cet appareil"}
            </ActionButton>
          )}

          {hasDevice && (
            <>
              <ActionButton
                icon={FaPaperPlane}
                onClick={sendTest}
                variant="success"
                disabled={testing || saving}
              >
                {testing ? "Envoi..." : "Tester une notification"}
              </ActionButton>

              <ActionButton
                icon={FaPowerOff}
                onClick={disableCurrentDevice}
                variant="secondary"
                disabled={saving}
              >
                Désactiver cet appareil
              </ActionButton>
            </>
          )}

          {hasAnyDevice && (
            <ActionButton
              icon={FaTimes}
              onClick={disableEverywhere}
              variant="danger"
              disabled={saving}
            >
              Désactiver partout
            </ActionButton>
          )}
        </div> */}
      </div>
    </div>
  );
}
